export const locationSettingsRouteNames = {
    company: 'company-settings-v2',
    locationBilling:{
        default: 'location-company-billing',
        billingV2:'location_billing-v2',
        transactions:'location_wallet_transactions-v2'
    },
    staff:{
        default:'staff',
        teams:'teams-v2',
        team:'team-v2' ,
    },
    automation: 'automation-settings__default',
    calendars:{
        default: 'calendar-settings__default',
        preferences:'calendar-settings__preferences',
        availability: 'calendar-settings__availability',
        connections: 'calendar-settings__connections',
        services:'services',
        newConnections:'connections-new'
    },
    phoneNumber: 'phone-number-v2',
    whatsapp: 'whatsapp-v1',
    emailService:{
        default: 'smtp-service-v2',
        dedicatedDomains:{
            default: 'location-dedicated-domain',
            addDomain: 'location-add-domain',
            verifyDomain: 'location-verify-domain',
            domainSettings: 'location-smtp-settings'
        },
        blacklistMonitorReports: 'blacklist-monitor-reports',
        postmasterTools: {
            opmTrafficStats: 'location-opm-traffic-stats',
            gpmTrafficStats: 'location-gpm-traffic-stats',
        }
    },
    reputation: 'settings-reputation-v2',
    fields: 'custom-fields-settings-v2',
    customValues: 'custom-values-settings-v2',
    scoring: 'scoring',
    domain: 'domain-settings-v2',
    URLRedirect: 'redirect-settings-v2',
    externalTracking: 'external-tracking-settings-v2',
    conversationProviders: 'conversation_providers',
    tags: 'tags-settings-v2',
    labs: 'labs',
    auditLogs: 'audit-location-v2',
    privateIntegrations: {
        default: 'private-integrations',
        list: 'sub-app-private-integration-list',
        appId: 'sub-app-private-integration',
        appIdEdit: 'sub-app-private-integration-edit',
    },
    integrations: {
        default: 'integrations-v2',
        list: 'integrations-settings-v2',
        facebook: 'facebook_settings-v2',
        tiktok: 'tiktok_settings-v2',
        linkedIn: 'linkedin_settings-v2',
        facebookForms: 'facebook_forms_settings-v2',
        gbpPages: 'gbp-v2',
    },
    lcIntegrations: {
        default: 'lc-integrations',
    },
    pipeline: 'pipeline-settings-v2',
    smartList: 'smart-list-settings-v2',
    business: 'business-settings-v2',
    customEmails: 'custom-emails-settings-v2',
}  